var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSqrMeters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5225 13.4725V10.1368H24.9996V21.6751H17.5225V18.7528",
    stroke: "#322D60",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2402 10.1368H17.5231",
    stroke: "#322D60",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5228 21.6751H1V10.1368H8.36974",
    stroke: "#322D60",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49297 1H4.81348V10.1368",
    stroke: "#322D60",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5222 10.1368V1H14.8418",
    stroke: "#322D60",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1866 14.7188H12.6987C12.6987 14.7188 14.0577 13.6016 14.0577 13.0376C14.0577 12.2587 13.107 12.0439 12.6826 12.7207",
    stroke: "#322D60",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66797 19.1074V14.4178M5.78077 15.7072C6.04935 15.2506 6.59724 14.8264 7.39223 14.8264C8.04756 14.8264 8.54174 15.2239 8.74586 15.7879H8.76734C8.91774 15.5194 9.10575 15.3152 9.29912 15.1648C9.58381 14.9445 9.90074 14.8264 10.3573 14.8264C10.9912 14.8264 11.7485 15.2401 11.7485 16.9053V19.1126",
    stroke: "#322D60",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76758 15.7822V19.0859",
    stroke: "#322D60",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSqrMeters);
export default __webpack_public_path__ + "static/media/SqrMeters.9926a7178d018852dad40fea1f95d438.svg";
export { ForwardRef as ReactComponent };